<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import SlideMenuComponent from "@/components/SlideMenuComponent.vue";
import {mapState} from "vuex";
import axios from "@/utils/axios";
import {formatTimestamp} from "@/utils/utils";

export default {
  name: "HashRateView",
  components: {SlideMenuComponent, HeaderComponent},
  data() {
    return {
      showList: false,
      interval: null,
      totalHashRate: 0,
      myRank: 0,
      directReferralHashrate: 0,
      tiersHashrate: 0,
      teamHashrate: 0,
      AttenuationHashrate: 0,
      user: {
        baseHashRate: 0,
        tradeAmount: 0,
      },
      myHistory: []
    }
  },
  computed: {
    ...mapState(['wallet_address', 'wallet_type']), // 映射 state
  },
  methods: {
    formatTimestamp,
    async load() {
      if (this.wallet_address) {
        const resp = await axios.get("/api/mining/" + this.wallet_address)
        console.log(resp)
        this.totalHashRate = resp.data.data.totalHashRate;
        this.myRank = resp.data.data.myRank;
        if (resp.data.data.myAccount) {
          this.user = resp.data.data.myAccount;
          this.directReferralHashrate = resp.data.data.directReferralHashrate;
          this.tiersHashrate = resp.data.data.tiersHashrate;
          this.teamHashrate = resp.data.data.teamHashrate;
          this.attenuationHashrate = resp.data.data.attenuationHashrate;

        }

        const historyResp = await axios.get("/api/history/" + this.wallet_address);
        console.log(historyResp)
        if (historyResp.data.data) {
          this.myHistory = historyResp.data.data.myHistory;
        }
      }
    }
  },
  mounted() {
    this.load();

    this.interval = setInterval(() => {
      this.load()
    }, 3 * 1000)
  },
  unmounted() {
    clearInterval(this.interval)
  }
}
</script>

<template>
  <div>
    <HeaderComponent/>
    <SlideMenuComponent/>
    <div class="index">
      <div class="section8">
        <div class="block1">
          <div class="item">
            <div class="val">{{ totalHashRate }}</div>
            <div class="title">{{ $t('totalNetworkHashrate') }}</div>
            <div class="line"></div>
          </div>
          <div class="item">
            <div class="val">{{ myRank }}</div>
            <div class="title">{{ $t('myRanking') }}</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="block2">
          <div class="title">
            <div class="lef">
              <img src="images/cir2.png" alt="">
              <span>{{ $t("hashrate") }}</span>
            </div>
            <div class="ris"></div>
          </div>
          <div class="content">
            <div class="dec">
              <p>
                <span class="s1">{{ $t("baseHashrate") }}</span>
                <span class="s2">{{ user.baseHashRate }}</span>
              </p>
              <p>
                <span class="s1">{{ $t("directReferralHashrate") }}</span>
                <span class="s2">{{ directReferralHashrate }}</span>
              </p>
              <p>
                <span class="s1">{{ $t("tiersHashrate") }}</span>
                <span class="s2">{{ tiersHashrate }}</span>
              </p>
              <p>
                <span class="s1">{{ $t("teamHashrate") }}</span>
                <span class="s2">{{ teamHashrate }}</span>
              </p>
              <p>
                <span class="s1">{{ $t("attenuationHashrate") }}</span>
                <span class="s2">{{ attenuationHashrate }}</span>
              </p>
              <p>
                <span class="s1">{{ $t("totalHashrate") }}</span>
                <span class="s2">{{ user.baseHashRate + tiersHashrate + teamHashrate - AttenuationHashrate }}</span>
              </p>
              <p>
                <span class="s1">{{ $t("hashrateRecord") }}</span>
                <span class="s2"><a href="javascript:;" class="slide" @click="showList=!showList"></a></span>
              </p>
              <div class="last type0" v-show="showList">
                <table width="100%" border="0" cellspacing="0" cellpadding="0" class="">
                  <tr v-for="item in myHistory" :key="item.id">
                    <td>{{ item.usdtAmount * 100}}</td>
                    <td>{{ $t("buy_base_hashrate") }}</td>
                    <td>{{ formatTimestamp(item.createdAt)}}</td>
                  </tr>
                  <!--                  <tr>-->
                  <!--                    <td>145</td>-->
                  <!--                    <td>{{ $t("directReferralHashrate") }}</td>-->
                  <!--                    <td>2025.3.29 15:45</td>-->
                  <!--                  </tr>-->
                  <!--                  <tr>-->
                  <!--                    <td>145</td>-->
                  <!--                    <td>{{ $t("tiersHashrate") }}</td>-->
                  <!--                    <td>2025.3.29 15:45</td>-->
                  <!--                  </tr>-->
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>